import { thunk } from 'easy-peasy';
import { Auth } from 'aws-amplify';
import AWS from 'aws-sdk';
import { awsAuthAdmin, awsAuthCollaborator } from './config/awsCognito';
import { initAWSSDK } from '../../hooks/awsHelpers';

const middleware = {
  //✨✨===========================================✨✨
  //            CONNEXTION USER AWS COGNITO ADMIN
  //✨✨===========================================✨✨
  loginAws: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    getStoreActions().global.setActivity(true);
    try {
      const user = await Auth.signIn(
        payload?.mail,
        payload?.password
      );
      getStoreActions().userData.setCognitoData(user);
      return user;
    } catch (error) {
      getStoreActions().global.setActivity(false);

      console.log('AUTH ERROR RAW =>', error);
      console.log('AUTH ERROR CODE =>', error?.code);
      console.log('AUTH ERROR MESSAGE =>', error?.message);

      throw error;
    }
  }),

  //✨✨===========================================✨✨
  //            VERIF IS AUTH COGNITO ADMIN
  //✨✨===========================================✨✨
  isAuth: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    try {
      const user = await Auth.currentAuthenticatedUser();
      getStoreActions().userData.setCognitoData(user);
      return user;
    } catch (error) {
      throw error;
    }
  }),

  //✨✨=============================================✨✨
  //            CREATE USER AWS COGNITO ADMIN
  //✨✨=============================================✨✨
  createAdminUser: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    getStoreActions().global.setActivity(true);
    try {
      const user = await Auth.signUp({
        username: payload?.mail,
        password: payload?.password,
      });
      return user;
    } catch (error) {
      getStoreActions().global.setActivity(false);
      throw error;
    }
  }),

  //✨✨=============================================✨✨
  //            LOGOUT USER COGNITO ADMIN
  //✨✨=============================================✨✨
  logOutAdminUser: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    try {
      await Auth.signOut();
      getStoreActions().route.setConnected(false);
    } catch (error) {
      throw error;
    }
  }),

  //✨✨=============================================✨✨
  //            SET PASSWORD AWS SDK ADMIN
  //✨✨=============================================✨✨
  setAdminPassword: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    // Init AWS SDK
    await initAWSSDK();

    // Cognito config
    const awsCognito = new AWS.CognitoIdentityServiceProvider();

    // props func Aws
    const data = {
      Password: payload?.password,
      Permanent: true,
      Username: payload?.id_cognito,
      UserPoolId: awsAuthAdmin.userPoolId,
    };

    // exe aws function
    const myPromesse = new Promise((resolve, reject) => {
      awsCognito.adminSetUserPassword(data, (err) => {
        if (err) {
          getStoreActions().global.setActivity(false);
          reject(err);
        } else {
          resolve(data);
        }
      });
    });

    return myPromesse;
  }),

  //✨✨=============================================✨✨
  //            SET EMAIL AWS SDK ADMIN
  //✨✨=============================================✨✨
  setAdminEmail: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    // Init AWS SDK
    await initAWSSDK();

    // Cognito config
    const awsCognito = new AWS.CognitoIdentityServiceProvider();

    // props func Aws
    const data = {
      UserAttributes: [
        {
          Name: 'email',
          Value: payload?.mail,
        },
        {
          Name: 'email_verified',
          Value: 'true', // La valeur doit être une chaîne, pas un booléen
        },
      ],
      Username: payload?.id_cognito,
      UserPoolId: awsAuthAdmin.userPoolId,
    };

    // exe aws function
    const myPromesse = new Promise((resolve, reject) => {
      awsCognito.adminUpdateUserAttributes(data, (err) => {
        if (err) {
          getStoreActions().global.setActivity(false);
          reject(err);
        } else {
          resolve(data);
        }
      });
    });

    return myPromesse;
  }),

  //✨✨=============================================✨✨
  //            DELETE USER AWS SDK ADMIN COGNITO
  //✨✨=============================================✨✨
  deleteAdminUserCognito: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    // Init AWS SDK
    await initAWSSDK();

    // Cognito config
    const awsCognito = new AWS.CognitoIdentityServiceProvider();

    // props func Aws
    const data = {
      Username: payload,
      UserPoolId: awsAuthAdmin.userPoolId,
    };
    getStoreActions().global.setActivity(true);
    // exe aws function
    const myPromesse = new Promise((resolve, reject) => {
      awsCognito.adminDeleteUser(data, (err) => {
        if (err) {
          getStoreActions().global.setActivity(false);
          reject(err);
        } else {
          resolve(data);
        }
      });
    });

    return myPromesse;
  }),

  //✨✨=============================================✨✨
  //            SET PASSWORD AWS SDK COLLABORARTOR
  //✨✨=============================================✨✨
  setCollaboratorPassword: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    console.log('payload setCollaboratorPassword', payload);
    // Init AWS SDK
    await initAWSSDK();

    // Cognito config
    const awsCognito = new AWS.CognitoIdentityServiceProvider();

    // props func Aws
    const data = {
      Password: payload?.password,
      Permanent: true,
      Username: payload?.id_cognito,
      UserPoolId: awsAuthCollaborator.userPoolId,
    };

    // exe aws function
    const myPromesse = new Promise((resolve, reject) => {
      awsCognito.adminSetUserPassword(data, (err) => {
        if (err) {
          console.log('err', err);
          getStoreActions().global.setActivity(false);
          reject(err);
        } else {
          resolve(data);
        }
      });
    });

    return myPromesse;
  }),

  //✨✨=============================================✨✨
  //            SET USERNAME AWS SDK COLLABORATOR
  //✨✨=============================================✨✨
  setCollaboratorUsername: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    console.log('payload setCollaboratorUsername', payload);

    // Init AWS SDK
    await initAWSSDK();

    // Cognito config
    const awsCognito = new AWS.CognitoIdentityServiceProvider();

    // props func Aws
    const data = {
      UserAttributes: [
        {
          Name: 'preferred_username',
          Value: payload.fullName,
        },
      ],
      UserPoolId: awsAuthCollaborator.userPoolId,
      Username: payload.id_cognito,
    };
    getStoreActions().global.setActivity(true);
    // exe aws function
    const myPromesse = new Promise((resolve, reject) => {
      awsCognito.adminUpdateUserAttributes(data, (err) => {
        if (err) {
          console.log('err', err);
          getStoreActions().global.setActivity(false);
          reject(err);
        } else {
          resolve(data);
        }
      });
    }).catch((err) => {
      console.log('err', err);
      getStoreActions().global.setActivity(false);
      throw err;
    }
    ).finally(() => {
      getStoreActions().global.setActivity(false);
    });

    return myPromesse;
  }),

  //✨✨=============================================✨✨
  //            SET PHONE NUMBER AWS SDK COLLABORATOR
  //✨✨=============================================✨✨
  setCollaboratorPhoneNumber: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    console.log('payload setCollaboratorPhoneNumber', payload);
    // Init AWS SDK
    await initAWSSDK();

    // Cognito config
    const awsCognito = new AWS.CognitoIdentityServiceProvider();

    // Vérification du format du numéro de téléphone (E.164)
    if (!/^\+\d{1,15}$/.test(payload?.phone)) {
      throw new Error('Le numéro de téléphone doit être au format E.164 (ex: +33612345678).');
    }

    const params = {
      UserAttributes: [
        { Name: 'phone_number', Value: payload?.phone },
        { Name: 'phone_number_verified', Value: 'true' }, // Valeur correcte en chaîne
      ],
      Username: payload?.id_cognito,
      UserPoolId: awsAuthCollaborator.userPoolId,
    };

    try {
      getStoreActions().global.setActivity(true);

      // Appel AWS SDK avec gestion des promesses
      await awsCognito.adminUpdateUserAttributes(params).promise();

      return { success: true, message: 'Numéro de téléphone mis à jour avec succès.' };
    } catch (error) {
      console.error('Erreur AWS Cognito :', error);
      throw new Error('Impossible de mettre à jour le numéro de téléphone.');
    } finally {
      // Désactive toujours l'indicateur d'activité
      getStoreActions().global.setActivity(false);
    }
  }),

  //✨✨=============================================✨✨
  //            DELETE USER AWS SDK COLLABORATOR COGNITO
  //✨✨=============================================✨✨
  deleteCollaboratorUserCognito: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    // Init AWS SDK
    await initAWSSDK();

    // Cognito config
    const awsCognito = new AWS.CognitoIdentityServiceProvider();

    // props func Aws
    const data = {
      Username: payload,
      UserPoolId: awsAuthCollaborator.userPoolId,
    };
    getStoreActions().global.setActivity(true);
    // exe aws function
    const myPromesse = new Promise((resolve, reject) => {
      awsCognito.adminDeleteUser(data, (err) => {
        if (err) {
          getStoreActions().global.setActivity(false);
          reject(err);
        } else {
          resolve(data);
        }
      });
    });

    return myPromesse;
  }),

  //✨✨=============================================✨✨
  //          CREATE USER AWS COGNITO COLLABORATOR
  //✨✨=============================================✨✨
  createFullCollaborator: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    getStoreActions().global.setActivity(true);
    try {
      await initAWSSDK(); // Doit initialiser AWS.config.credentials avec IAM autorisé

      const awsCognito = new AWS.CognitoIdentityServiceProvider();

      const userPoolId = awsAuthCollaborator.userPoolId;
      const username = payload.id_cognito;

      // Étape 1 – Créer l’utilisateur avec mot de passe temporaire
      await awsCognito.adminCreateUser({
        UserPoolId: userPoolId,
        Username: username,
        TemporaryPassword: payload.password,
        MessageAction: 'SUPPRESS', // Ne pas envoyer d’email automatique
      }).promise();

      // Étape 2 – Définir un mot de passe permanent
      await awsCognito.adminSetUserPassword({
        UserPoolId: userPoolId,
        Username: username,
        Password: payload.password,
        Permanent: true,
      }).promise();

      // Étape 3 – Ajouter preferred_username (nom complet)
      await awsCognito.adminUpdateUserAttributes({
        UserPoolId: userPoolId,
        Username: username,
        UserAttributes: [
          {
            Name: 'preferred_username',
            Value: payload.fullName,
          },
        ],
      }).promise();

      // Étape 4 – Ajouter le numéro de téléphone (format E.164)
      if (payload.phone && /^\+\d{1,15}$/.test(payload.phone)) {
        await awsCognito.adminUpdateUserAttributes({
          UserPoolId: userPoolId,
          Username: username,
          UserAttributes: [
            { Name: 'phone_number', Value: payload.phone },
            { Name: 'phone_number_verified', Value: 'true' },
          ],
        }).promise();
      }

      console.log('✅ Collaborateur Cognito créé avec succès');
      return { success: true };

    } catch (error) {
      getStoreActions().global.setActivity(false);
      console.error('❌ Erreur lors de la création du collaborateur :', error);
      throw error;
    }
  }),
};

export default middleware;

